import { SIDEBAR_MENU } from 'constants/layout';
import CalendarProvider from 'providers/Calendar';
import ReportValuesProvider from 'providers/ReportValues';
import { Navigate, Outlet, RouteObject, useRoutes } from 'react-router-dom';
import { useEffect } from 'react';
import { useAppDispatch } from 'store/hooks';
import { initTours } from 'store/tour/slice';

import { PrivateLayout } from 'components/layout';
import Appointments from 'pages/Appointments';
import AppointmentsDetails from 'pages/AppointmentsDetails';
import Calendar from 'pages/Calendar';
import Dashboard from 'pages/Dashboard';
import Dicom from 'pages/Dicom';
import HowItWorks from 'pages/HowItWorks';
import Invoices from 'pages/Invoices';
import MyProfile from 'pages/MyProfile';
import Patients from 'pages/Patients';
import PdfViewer from 'pages/PdfViewer';
import Reports from 'pages/Report';
import { MedicusReports, PersonalReports } from 'pages/Report/components';
import ReportDetails from 'pages/ReportDetails';
import VideoCall from 'pages/VideoCall';

const privateRoutes: RouteObject[] = [
  {
    path: '',
    element: <Dashboard />
  },
  {
    path: '/calendar',
    element: (
      <CalendarProvider>
        <Calendar />
      </CalendarProvider>
    )
  },
  {
    path: '/appointments',
    element: <Outlet />,
    children: [
      {
        path: '',

        element: <Appointments />
      },
      {
        path: 'details/:id',
        element: <AppointmentsDetails />
      }
    ]
  },
  {
    path: '/radiology',
    element: <Outlet />,
    children: [
      {
        path: '',
        element: <Appointments />
      },
      {
        path: 'details/:id',
        element: <AppointmentsDetails />
      }
    ]
  },
  {
    path: '/patients/:id?',
    element: <Patients />
  },
  {
    path: '/my-profile/:id',
    element: <MyProfile />
  },
  {
    path: '/report',
    element: <Reports />,
    children: [
      {
        path: 'medicus',
        element: <MedicusReports />
      },
      {
        path: 'personal',
        element: <PersonalReports />
      }
    ]
  },
  {
    path: '/report/details/:id?',
    element: (
      <ReportValuesProvider>
        <ReportDetails />
      </ReportValuesProvider>
    )
  },
  {
    path: '/invoices',
    element: <Invoices />
  },
  {
    path: '/video-call',
    element: <VideoCall />
  },
  {
    path: '/dicom',
    element: <Dicom />
  },
  {
    path: '/how-it-works/:id',
    element: <HowItWorks />
  },
  {
    path: '/pdf-viewer/:id',
    element: <PdfViewer />
  },
  {
    path: '*',
    element: <Navigate to="/" />
  }
];

const PrivateRoutes = () => {
  const routers = useRoutes(privateRoutes);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(initTours());
  }, [dispatch]);

  return <PrivateLayout sidebarMenu={SIDEBAR_MENU}>{routers}</PrivateLayout>;
};

export default PrivateRoutes;
